import type { OrganizationTeam, UserResource } from "./types";

export function sampleOrganizationTeams(): OrganizationTeam[] {
  return [
    {
      id: "team_pmo",
      name: "PMO 사업관리팀",
      description: "사업 총괄 관리 및 공정·예산 통제",
      leaderId: "res_kim_pm",
      color: "#0078d4",
      icon: "briefcase",
    },
    {
      id: "team_arch",
      name: "플랫폼 아키텍처팀",
      description: "코어 프레임워크, 클라우드 인프라 및 DB",
      leaderId: "res_lee_arch",
      color: "#8764b8",
      icon: "code",
    },
    {
      id: "team_biz",
      name: "비즈니스 솔루션개발팀",
      description: "도메인 업무 프로세스 및 프론트/백엔드",
      leaderId: "res_choi_plan",
      color: "#107c41",
      icon: "rocket",
    },
    {
      id: "team_partner",
      name: "외부 협력단 & 프리랜서",
      description: "특정 도메인 전문 외주 및 전문 프리랜서 풀",
      color: "#008272",
      icon: "building",
    },
    {
      id: "team_robot",
      name: "AI·로봇 엔지니어링",
      description: "매니퓰레이터, 비전검사, 제어 시퀀스",
      leaderId: "res_han_robot",
      color: "#be3528",
      icon: "flash",
    },
    {
      id: "team_qa",
      name: "품질보증",
      description: "테스트 설계, 수율·결함 관리, 인수 지원",
      leaderId: "res_oh_qa",
      color: "#f18e35",
      icon: "target",
    },
    {
      id: "team_data",
      name: "데이터·분석",
      description: "CDP, ML 파이프라인, 실험 설계",
      leaderId: "res_yoon_data",
      color: "#9649b0",
      icon: "grid",
    },
    {
      id: "team_growth",
      name: "마케팅·그로스",
      description: "캠페인, CRM, 개인화 그로스 운영",
      leaderId: "res_lim_growth",
      color: "#da5978",
      icon: "megaphone",
    },
  ];
}

export function sampleUserResources(): UserResource[] {
  return [
    {
      id: "res_me",
      displayName: "나",
      email: "me@wavex.local",
      roleTitle: "워크스페이스 소유자",
      teamId: "team_pmo",
      employmentType: "permanent",
      grade: "principal",
      skills: ["PMO", "현황 보고", "이해관계자", "기준선"],
      defaultMonthlyRate: 10000000,
      defaultDailyRate: 500000,
      avatarColor: "#0f6cbd",
      isActive: true,
      notes: "로그인한 사용자. 각 워크스페이스에서 두 플랜의 사업 소유자",
    },
    {
      id: "res_kim_pm",
      displayName: "김PM",
      email: "kim.pm@wavex.io",
      roleTitle: "프로젝트 총괄 PM",
      teamId: "team_pmo",
      employmentType: "permanent",
      grade: "principal",
      skills: ["PMP", "애자일", "WBS/CPM", "리스크관리"],
      defaultMonthlyRate: 12000000,
      defaultDailyRate: 600000,
      avatarColor: "#0078d4",
      isActive: true,
      notes: "대형 SI 15년 경력 PM",
    },
    {
      id: "res_lee_arch",
      displayName: "이아키",
      email: "lee.arch@freelance.net",
      roleTitle: "수석 솔루션 아키텍트",
      teamId: "team_arch",
      employmentType: "freelance",
      grade: "principal",
      skills: ["Spring Cloud", "MSA", "Kubernetes", "EDA"],
      defaultMonthlyRate: 13500000,
      defaultDailyRate: 675000,
      avatarColor: "#8764b8",
      isActive: true,
      notes: "MSA 아키텍처 전문 프리랜서 계약",
    },
    {
      id: "res_park_dev",
      displayName: "박엔진",
      email: "park.engine@partner-c.com",
      roleTitle: "코어 백엔드 PL",
      teamId: "team_partner",
      employmentType: "partner",
      grade: "senior",
      skills: ["Java", "Oracle", "High-Throughput", "MES 연동"],
      defaultMonthlyRate: 9500000,
      defaultDailyRate: 475000,
      avatarColor: "#d83b01",
      isActive: true,
      notes: "파트너C 협력사 상주 개발인력",
    },
    {
      id: "res_choi_plan",
      displayName: "최기획",
      email: "choi.plan@wavex.io",
      roleTitle: "업무 분석 / BA 파트장",
      teamId: "team_biz",
      employmentType: "permanent",
      grade: "senior",
      skills: ["제조/ERP", "SCM", "요구사항정의", "Figma"],
      defaultMonthlyRate: 9000000,
      defaultDailyRate: 450000,
      avatarColor: "#107c41",
      isActive: true,
      notes: "제조 프로세스 현업 인터뷰 리드",
    },
    {
      id: "res_jung_front",
      displayName: "정프론트",
      email: "jung.ui@wavex.io",
      roleTitle: "웹 프론트엔드 개발자",
      teamId: "team_biz",
      employmentType: "permanent",
      grade: "mid",
      skills: ["React", "TypeScript", "Tailwind", "Design System"],
      defaultMonthlyRate: 7500000,
      defaultDailyRate: 375000,
      avatarColor: "#008272",
      isActive: true,
      notes: "Planner & 대시보드 컴포넌트 전담",
    },
    {
      id: "res_kang_infra",
      displayName: "강인프라",
      email: "kang.cloud@freelance.net",
      roleTitle: "클라우드 / DevOps 엔지니어",
      teamId: "team_arch",
      employmentType: "freelance",
      grade: "senior",
      skills: ["AWS", "Terraform", "CI/CD", "Prometheus"],
      defaultMonthlyRate: 10000000,
      defaultDailyRate: 500000,
      avatarColor: "#498205",
      isActive: true,
      notes: "복수 프로젝트 인프라 공통 지원 가능",
    },
    {
      id: "res_song_dba",
      displayName: "송DB",
      email: "song.dba@wavex.io",
      roleTitle: "데이터 모델러 / DBA",
      teamId: "team_arch",
      employmentType: "contract",
      grade: "senior",
      skills: ["Oracle RAC", "PostgreSQL", "데이터이관", "튜닝"],
      defaultMonthlyRate: 10500000,
      defaultDailyRate: 525000,
      avatarColor: "#5c2d91",
      isActive: true,
      notes: "이관 리허설 및 쿼리 최적화 전담",
    },
    {
      id: "res_han_robot",
      displayName: "한로봇",
      email: "han.robot@wavex.io",
      roleTitle: "로봇 라인 총괄 PL",
      teamId: "team_robot",
      employmentType: "permanent",
      grade: "principal",
      skills: ["산업용로봇", "셀 설계", "양산이관", "안전규격"],
      defaultMonthlyRate: 14000000,
      defaultDailyRate: 700000,
      avatarColor: "#be3528",
      isActive: true,
      notes: "자동차·전자 라인 로봇셀 12년",
    },
    {
      id: "res_na_vision",
      displayName: "나비전",
      email: "na.vision@freelance.net",
      roleTitle: "비전 AI 엔지니어",
      teamId: "team_robot",
      employmentType: "freelance",
      grade: "senior",
      skills: ["Computer Vision", "PyTorch", "불량검출", "ONNX"],
      defaultMonthlyRate: 11000000,
      defaultDailyRate: 550000,
      avatarColor: "#c50f1f",
      isActive: true,
      notes: "외관검사 모델 특화 프리랜서",
    },
    {
      id: "res_baek_ctrl",
      displayName: "백제어",
      email: "baek.ctrl@partner-robot.com",
      roleTitle: "로봇 제어 엔지니어",
      teamId: "team_partner",
      employmentType: "partner",
      grade: "senior",
      skills: ["PLC", "ROS2", "모션제어", "안전PLC"],
      defaultMonthlyRate: 9800000,
      defaultDailyRate: 490000,
      avatarColor: "#ca5010",
      isActive: true,
      notes: "로봇벤더 협력사 상주 제어 인력",
    },
    {
      id: "res_oh_qa",
      displayName: "오품질",
      email: "oh.qa@wavex.io",
      roleTitle: "품질보증 파트장",
      teamId: "team_qa",
      employmentType: "permanent",
      grade: "senior",
      skills: ["테스트설계", "인수 테스트", "수율관리", "이슈트래킹"],
      defaultMonthlyRate: 8500000,
      defaultDailyRate: 425000,
      avatarColor: "#f18e35",
      isActive: true,
      accountDeleted: true,
      notes: "제조·SI 품질 검수를 겸하고, 여러 플랜의 고객 인수를 맡는다",
    },
    {
      id: "res_min_qa",
      displayName: "민테스터",
      email: "min.qa@wavex.io",
      roleTitle: "QA 엔지니어",
      teamId: "team_qa",
      employmentType: "permanent",
      grade: "junior",
      skills: ["수동테스트", "체크리스트", "버그보고", "Playwright"],
      defaultMonthlyRate: 4500000,
      defaultDailyRate: 225000,
      avatarColor: "#ffaa44",
      isActive: true,
      notes: "신입 2년차 · 파일럿 셀·캠페인 회귀 담당",
    },
    {
      id: "res_yoon_data",
      displayName: "윤데이터",
      email: "yoon.data@wavex.io",
      roleTitle: "데이터 분석 파트장",
      teamId: "team_data",
      employmentType: "permanent",
      grade: "senior",
      skills: ["CDP", "실험설계", "SQL", "대시보드"],
      defaultMonthlyRate: 10200000,
      defaultDailyRate: 510000,
      avatarColor: "#9649b0",
      isActive: true,
      notes: "수율 분석과 마케팅 실험 설계를 겸임",
    },
    {
      id: "res_seo_ml",
      displayName: "서머신",
      email: "seo.ml@contract.wavex.io",
      roleTitle: "ML 엔지니어",
      teamId: "team_data",
      employmentType: "contract",
      grade: "mid",
      skills: ["Feature Store", "추천", "개인화", "Airflow"],
      defaultMonthlyRate: 7200000,
      defaultDailyRate: 360000,
      avatarColor: "#77488d",
      isActive: true,
      notes: "1년 계약 · 비전 학습 파이프라인과 추천 모델",
    },
    {
      id: "res_lim_growth",
      displayName: "임그로스",
      email: "lim.growth@wavex.io",
      roleTitle: "그로스 PM",
      teamId: "team_growth",
      employmentType: "permanent",
      grade: "senior",
      skills: ["그로스", "CRM", "캠페인", "OKR"],
      defaultMonthlyRate: 9200000,
      defaultDailyRate: 460000,
      avatarColor: "#da5978",
      isActive: true,
      notes: "커머스·구독 그로스 8년",
    },
    {
      id: "res_kwon_crm",
      displayName: "권CRM",
      email: "kwon.crm@wavex.io",
      roleTitle: "CRM / 마케팅 자동화 PL",
      teamId: "team_growth",
      employmentType: "permanent",
      grade: "mid",
      skills: ["Braze", "Segment", "여정설계", "이메일"],
      defaultMonthlyRate: 6800000,
      defaultDailyRate: 340000,
      avatarColor: "#e3008c",
      isActive: true,
      notes: "고객 여정·세그먼트 운영 전담",
    },
    {
      id: "res_jang_copy",
      displayName: "장카피",
      email: "jang.copy@freelance.net",
      roleTitle: "콘텐츠 / 카피라이터",
      teamId: "team_growth",
      employmentType: "freelance",
      grade: "mid",
      skills: ["카피", "랜딩", "A/B 문구", "브랜드톤"],
      defaultMonthlyRate: 6200000,
      defaultDailyRate: 310000,
      avatarColor: "#b146c2",
      isActive: true,
      notes: "캠페인 카피·랜딩 전담 프리랜서",
    },
    {
      id: "res_cho_partner",
      displayName: "최파트너",
      email: "cho.partner@studio.example",
      roleTitle: "캠페인 파트너",
      employmentType: "freelance",
      grade: "mid",
      skills: ["캠페인", "콘텐츠"],
      defaultMonthlyRate: 5500000,
      defaultDailyRate: 275000,
      avatarColor: "#8a8886",
      isActive: true,
      notes: "초대를 보냈고 아직 들어오지 않음",
    },
    {
      id: "res_shin_spec",
      displayName: "신자문",
      email: "shin.spec@advisor.kr",
      roleTitle: "제조 DX 전문기술위원",
      teamId: "team_pmo",
      employmentType: "contract",
      grade: "specialist",
      skills: ["제조DX", "투자심의", "거버넌스", "표준화"],
      defaultMonthlyRate: 16000000,
      defaultDailyRate: 800000,
      avatarColor: "#20337a",
      isActive: true,
      notes: "월 일부 투입 · ERP·로봇 공장 자문",
    },
  ];
}
